import React from 'react';

const Loader = () => {
  return <div>LOADING....</div>;
};

export default Loader;
